import { shouldGetWelcomeBackPageTest } from "services/ab-tests/acquisition-ab-test-service";
import { getAbTestVariantNew } from "services/new-ab-tests/new-ab-tests-service";
import { WELCOME_BACK_PAGE_TEST } from "constants/new-ab-tests";
import {
  WELCOME_PAGE_FULL_PATH,
  PLATFORM_VISITOR_AB_TEST_NAME_PARAM_NAME,
  PLATFORM_VISITOR_AB_TEST_VARIANT_PARAM_NAME
} from "constants/welcome-page-constants";
import { ACTIVE_ACCOUNTS_SLUGS_COOKIE_NAME } from "services/monday-platform/existing-accounts-service";
import { getSlugDataInlineScript } from "/utils/inline-scripts";

const platformDomain = process.env.PLATFORM_DOMAIN;

const RedirectToPlatfromScript = ({ abTests, persistantCookies }) => {
  const shouldGetWelcomeBackPage = shouldGetWelcomeBackPageTest(abTests, persistantCookies);
  const welcomeBackVariant = getAbTestVariantNew(abTests, WELCOME_BACK_PAGE_TEST.test_name, false);

  const insertUrlRedirectDefinition = () => {
    let platformTestParams = "";

    if (shouldGetWelcomeBackPage) {
      return `appUrl = "${WELCOME_PAGE_FULL_PATH}";`;
    }

    if (welcomeBackVariant) {
      platformTestParams = `?${PLATFORM_VISITOR_AB_TEST_NAME_PARAM_NAME}=${WELCOME_BACK_PAGE_TEST.test_name}&${PLATFORM_VISITOR_AB_TEST_VARIANT_PARAM_NAME}=${welcomeBackVariant}`;
    }

    return `
          appUrl = "//"+lastActiveSlug + ".${platformDomain}${platformTestParams}";
    `;
  };

  const redirectToPlatformIfNeeded = () => {
    return `
        ${getSlugDataInlineScript}
        var cookie = document.cookie
        var mondayActiveAccountsCookieKey = "${ACTIVE_ACCOUNTS_SLUGS_COOKIE_NAME}=";
        var mondayActiveAccountsString = cookie.split(';').filter(function(item) {
            return item.indexOf(mondayActiveAccountsCookieKey) >= 0
        })[0];
        mondayActiveAccountsString = mondayActiveAccountsString || "[]";
        mondayActiveAccountsValueString = mondayActiveAccountsString.replace(mondayActiveAccountsCookieKey, "");
        mondayActiveAccounts = JSON.parse(decodeURIComponent(mondayActiveAccountsValueString));  
        var path = window.location.pathname.trim();;
        var normalizedPath = path.endsWith("/") ? path : path + "/";
        if((normalizedPath === "/") && mondayActiveAccounts.length > 0 && mondayActiveAccounts.indexOf("monday") === -1) {
          var lastActiveSlug = mondayActiveAccounts[mondayActiveAccounts.length - 1];
          var appUrl = "//"+lastActiveSlug + ".${platformDomain}";
          const singleNewSlugFirstUser = onlyNewFirstUserSlug(new Date("${WELCOME_BACK_PAGE_TEST.launch_date}"));
          if (singleNewSlugFirstUser) {
            ${insertUrlRedirectDefinition()}
          }
           
          window.location.replace(appUrl);
        }
    `;
  };

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: redirectToPlatformIfNeeded()
      }}
    />
  );
};

export default RedirectToPlatfromScript;
